import { z } from "zod";

import type { JP_CITIES } from "@/shared/constants/address";
import type {
  OFFER_CARGO_VEHICLE_SHAPES_LIST,
  PACKING_STYLES_LIST,
  VEHICLE_SIZES,
} from "@/shared/constants/offer-cargo";
import type { FreightMatching } from "@x-mile/api-contract";

export type JP_PREFECTURE_TYPES = keyof typeof JP_CITIES;
export type VEHICLE_SHAPE_TYPE =
  (typeof OFFER_CARGO_VEHICLE_SHAPES_LIST)[0]["value"];
export type VEHICLE_SIZE_TYPE = (typeof VEHICLE_SIZES)[0]["value"];
export type PACKING_STYLE_TYPE = (typeof PACKING_STYLES_LIST)[0];

export const OfferCargoSearchFormSchema = z.object({
  loadingScheduleStart: z.string().optional(),
  loadingScheduleEnd: z.string().optional(),
  loadingLocationPrefecture: z
    .string()
    .transform((v) => v as JP_PREFECTURE_TYPES)
    .optional(),
  unloadingLocationPrefecture: z
    .string()
    .transform((v) => v as JP_PREFECTURE_TYPES)
    .optional(),
  packingStyle: z
    .string()
    .transform(
      (v) =>
        v as FreightMatching.schemas.OfferCargoCollectionRequestBodyPackingStyle,
    )
    .optional(),
  vehicleShape: z
    .string()
    .transform((v) => v as VEHICLE_SHAPE_TYPE)
    .optional(),
  shippingFee: z.number().optional(),
  isNew: z.boolean().optional(),
  isNotProposedYet: z.boolean().optional(),
});

export type OfferCargoSearchFormSchemaType = z.infer<
  typeof OfferCargoSearchFormSchema
>;
